import styles from './LoadingFrames.module.scss'

/**
 * LoadingFrames — overlay displayed while 360° frame images are preloading.
 *
 * Shows a blurred first-frame preview as background, a progress bar, and an
 * optional percentage counter. Disappears (`isLoaded = true`) once all frames
 * have fired their `onLoad` callbacks.
 *
 * Used by `ModelView` (hero section) and by `ProductFramePlayer` (unit axonometry).
 * The component is purely presentational — progress tracking is owned by the
 * parent hook (`useModelFrames` or equivalent).
 *
 * @param {object}      props
 * @param {number}      props.progress       — 0–100 integer
 * @param {boolean}     props.isLoaded       — when true the overlay fades out and unmounts
 * @param {string|null} props.previewSrc     — URL of first frame used as blur background; null = solid fill
 * @param {string}      [props.className]    — extra class for the container
 */
export function LoadingFrames({ progress, isLoaded, previewSrc, className }) {
  if (isLoaded) return null

  return (
    <div
      className={[styles.overlay, className].filter(Boolean).join(' ')}
      aria-hidden="true"
    >
      {previewSrc && (
        <img
          src={previewSrc}
          alt=""
          className={styles.preview}
          style={{ filter: `blur(${Math.max(0, Math.round(12 * (1 - progress / 100)))}px)` }}
          aria-hidden="true"
        />
      )}

      <div className={styles.barContainer}>
        <div
          className={styles.bar}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  )
}
